/**
 * Implementation of Dashboard route
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactNode, useState } from "react";
import { Outlet } from "react-router";
import DashboardLayout from "../../components/DashboardLayout";
import Settings from "../Settings";
import Widgets from "../Widgets";
import Dashboard from "./Dashboard";

export default function DashboardRoutes() {
  const [name, setName] = useState("")

  const dashboardRoutes: Record<string, ReactNode> = {
    "/widgets": <Widgets />,
    "/settings": <Settings />,
    "/home": <Dashboard />,
  };

  return (
    <DashboardLayout
      // contentNoPadding={window.location.pathname.startsWith(
      //   "/dashboard/settings"
      // )}
    >
      <Outlet />
    </DashboardLayout>
  );
}
